import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Fab from '@material-ui/core/Fab';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import CopyIcon from '@material-ui/icons/FileCopy';
import Forward from '@material-ui/icons/Forward';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import SiteExpansionPanel from '../Site/SiteExpansionPanel';
import { RENTERS } from '../../constants/routes';
import { KOBOO_RED_ERROR } from '../../constants/colors';

const styles = theme => ({
  card: {
    display: 'flex',
    justifyContent: 'center',
  },
  fullParent: {
    width: '100%',
  },
  expansionList: {
    marginTop: '0.4em',
  },
  content: {
    flex: '1 0 auto',
    paddingBottom: '20px',
    paddingTop: '20px',
    fontSize: '2em',
    width: '100%',
  },
  infoText: {
    color: 'black',
  },
  error: {
    backgroundColor: 'red',
  },
  media: {
    display: 'block',
    maxWidth: 200,
    maxHeight: 95,
    width: 'auto',
    height: 'auto',
  },
  snackbar: {
    margin: theme.spacing(1),
  }
});

const endName = id => (
        <InputAdornment position="end">
            <Fab
              mini
              color="primary"
              aria-label="detail"
              component={Link}
              to={`${RENTERS}/${id}`}
            >
                <Forward />
            </Fab>
        </InputAdornment>
);

export class RenterBlock extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
    };

    copy = () => {
      navigator.clipboard.writeText(this.props.rib);
    };

    handleMouseDownPassword = (event) => {
      event.preventDefault();
    };

    render() {
      const { classes } = this.props;
      const endRib = <InputAdornment position="end">
            <IconButton
                aria-label="Copy rib"
                onClick={this.copy}
                onMouseDown={this.handleMouseDownPassword}
            >
                <CopyIcon />
            </IconButton>
        </InputAdornment>;

      return (
        <Grid item xs={12} sm={12} md={6} lg={4} className={classes.gridItem}>
          <Card className={classes.card}>
            <CardContent className={classes.content}>
              <img
                className={classes.media}
                src={this.props.logo}
                alt=''
              />
              <TextField
                className={classes.fullParent}
                disabled={true}
                id="name"
                label="Nom"
                value={this.props.name}
                margin="normal"
                InputProps={{
                  classes: {
                    root: classes.infoText,
                    input: classes.infoText,
                  },
                  disableUnderline: true,
                  endAdornment: endName(this.props.id),
                }}
              />
              <TextField
                className={classes.fullParent}
                disabled={true}
                id="rib"
                label="Rib"
                value={this.props.rib ? this.props.rib : 'Le rib n\'est pas défini'}
                margin="normal"
                InputProps={{
                  classes: {
                    root: classes.infoText,
                    input: classes.infoText,
                  },
                  disableUnderline: true,
                  endAdornment: this.props.rib && endRib,
                }}
              />
              <div className={(classes.fullParent, classes.expansionList)}>
                {!this.props.remove && this.props.sites && this.props.sites.map(site => (
                  <SiteExpansionPanel
                    {...site}
                    key={site.id}
                  />
                ))}
                {this.props.remove &&
                <SnackbarContent
                  className={classes.snackbar}
                  message="Ce loueur est désactivé"
                  style={{ backgroundColor: KOBOO_RED_ERROR }}
                />}
              </div>
            </CardContent>
          </Card>
        </Grid>);
    }
}


export default withStyles(styles)(RenterBlock);



// WEBPACK FOOTER //
// ./src/components/Renter/RenterBlock.jsx